/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  GamoraControllerContextIdentifier,
  GamoraFoundationGlueListenerType,
  GamoraFoundationNodeArgs,
  assert,
  debugCreate,
} from '@ver.id/libs.internal.gamora';
import {
  HoruzProtocolChulakServiceStateEvent,
  HoruzProtocolChulakServiceStateEventDoneInput,
  HoruzProtocolChulakServiceStateInvoker,
} from './enums.js';
import { HoruzProtocolChulakServiceStateBase } from './base.js';
import { HoruzProtocolChulakServiceStateContext } from '../context.js';
import { HoruzProtocolChulakServiceStateMap } from '../../statemap.js';
import { IHoruz } from '../../../../horuz.js';
const debug = debugCreate({
  namespace: 'horuz:protocols:chulak:states:server:done',
});

/**
 * Server
 *
 * Done state
 * @public
 */
export class HoruzProtocolChulakServiceStateDone extends HoruzProtocolChulakServiceStateBase<
  typeof HoruzProtocolChulakServiceStateMap,
  HoruzProtocolChulakServiceStateContext,
  IHoruz
> {
  constructor(args: GamoraFoundationNodeArgs) {
    super(args);
  }

  /**
   * Enter state
   */
  override async $enter(
    serviceStateContext: HoruzProtocolChulakServiceStateContext,
  ): Promise<void> {
    assert(
      serviceStateContext.stateContextRegistry.serviceSessionUuid,
      'Invalid argument: serviceSessionUuid not available in stateContextRegistry.',
    );
    // Emit done handler
    await this.$emit(
      serviceStateContext.contextIdentifier,
      HoruzProtocolChulakServiceStateEvent.Done,
      serviceStateContext,
      {
        serviceSessionUuid:
          serviceStateContext.stateContextRegistry.serviceSessionUuid,
      },
    );
  }

  /**
   * Exit state
   */
  override async $exit(
    serviceStateContext: HoruzProtocolChulakServiceStateContext,
  ): Promise<void> {}

  /**
   * Register invokers
   */
  on(
    contextIdentifier: GamoraControllerContextIdentifier,
    name: typeof HoruzProtocolChulakServiceStateEvent.Done,
    listener: (
      stateContext: HoruzProtocolChulakServiceStateContext,
      input: HoruzProtocolChulakServiceStateEventDoneInput,
    ) => Promise<void>,
  ): this;
  on<K extends keyof typeof HoruzProtocolChulakServiceStateInvoker>(
    contextIdentifier: GamoraControllerContextIdentifier,
    name: K,
    listener: GamoraFoundationGlueListenerType,
  ): this {
    return super.$on(contextIdentifier, name, listener);
  }
}
